













import Vue from 'vue'
import TableCollector from './table-collector.vue'
import TableField from './table-field.vue'

const { Splitpanes, Pane } = require('splitpanes')
import 'splitpanes/dist/splitpanes.css'

export default Vue.extend({
  name: 'CollectorManager',
  components: { Splitpanes, Pane, TableCollector, TableField },
  data() {
    return {
      collectorId: -1,
    }
  },

  methods: {
    onCollectorIdChanged(id: number) {
      this.collectorId = id
    },
  },
})
